import { useRef } from 'react'
import { InView } from 'react-intersection-observer'
import { COLLECTION_2_0_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import FlexibleLink from 'src/components/ui/FlexibleLink/FlexibleLink'
import { Picture } from 'src/components/ui/Image'
import { Statsig } from 'src/sdk/statsig'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getFeatureObject } from 'src/utils/amplitude/getFeatureObject'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'

interface InlineFullBannerProps {
  bannerUrlMobile: string
  bannerUrlDesktop: string
  imageDescription: string
  linkUrl: string
  promotionalName?: string
}

export function InlineFullBanner({
  bannerUrlMobile,
  bannerUrlDesktop,
  imageDescription,
  linkUrl,
  promotionalName,
}: InlineFullBannerProps) {
  const { pageData } = useGlobalContext()
  const standardObject = getStandardObject(pageData)
  const isCollection2Enabled = Statsig.useStatsigFeatureGateValue(
    COLLECTION_2_0_EXPERIMENT_ID
  )

  const hasDispatchedViewedEvent = useRef(false)

  const sendPromoFeatureViewedEvent = () => {
    if (hasDispatchedViewedEvent.current) {
      return
    }

    hasDispatchedViewedEvent.current = true

    dispatchAmplitudeEvent({
      eventName: 'Promo Feature Viewed',
      eventData: {
        ...standardObject,
        ...getFeatureObject({
          section: promotionalName ?? 'Banner livre',
          locationOnPage: 'bottom',
          name: promotionalName ?? 'Banner livre',
        }),
      },
    })
  }

  if (!isCollection2Enabled) {
    return null
  }

  return (
    <InView
      as="section"
      triggerOnce
      threshold={0.7}
      className="relative left-1/2 w-screen -translate-x-1/2"
      onChange={(inView) => {
        if (inView) {
          sendPromoFeatureViewedEvent()
        }
      }}
    >
      <FlexibleLink linkUrl={linkUrl} classNames="block w-screen">
        <Picture
          sources={[
            {
              src: bannerUrlMobile,
              width: 507,
              height: 270,
              media: '(max-width: 766px)',
              options: {
                fitIn: true,
              },
            },
            {
              src: bannerUrlDesktop,
              width: 1280,
              height: 340,
              media: '(min-width: 767px)',
              options: {
                fitIn: true,
              },
            },
          ]}
          img={{
            src: bannerUrlDesktop,
            alt: imageDescription ?? promotionalName ?? 'Banner Full',
            className:
              'cursor-pointer w-screen max-w-none h-auto object-contain',
          }}
        />
      </FlexibleLink>
    </InView>
  )
}
